<template>
  <div class="card bg-transparent border-0">
    <slot>
      <ul class="list-group list-group-flush left-list text-dark">
        <router-link tag="li" :to="{name:'agenda'}" class="list-group-item cursor-pointer mb-1">
          <img src="@img/book.svg" alt="book" class="w24x mr-2">
          <span>Agenda</span>
        </router-link>
        <template v-if="viewAgenda">
          <slot name="agenda"></slot>
        </template>
        <router-link tag="li" :to="{name:'exams'}" class="list-group-item cursor-pointer mb-1">
          <img src="@img/license.svg" alt="book" class="w24x mr-2">
          <span>Annales</span>
        </router-link>
        <template v-if="viewAnnales">
          <slot name="annales"></slot>
        </template>
        <router-link tag="li" :to="{name:'questions'}" class="list-group-item cursor-pointer mb-1">
          <img src="@img/discussion_dark.svg" alt="book" class="w24x mr-2">
          <span>Questions - Réponses</span>
        </router-link>
        <router-link tag="li" :to="{name:'subjects'}" class="list-group-item cursor-pointer mb-1">
          <img src="@img/subjects.svg" alt="subjects" class="w24x mr-2">
          <span>Matieres</span>
        </router-link>
        <router-link tag="li" :to="{name:'chat'}" class="list-group-item cursor-pointer mb-1">
          <img src="@img/discussion_dark.svg" alt="book" class="w24x mr-2">
          <span>Messagerie</span>
        </router-link>
      </ul>
    </slot>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    viewAgenda: {type: Boolean, default: false},
    viewAnnales: {type: Boolean, default: false},
  },
  data() {
    return {}
  },
};
</script>

<style lang="scss" scoped>
.list-group-item.active {
  border-color: #eee !important;
}
</style>
